import {
    GET_CURATION_SUCCESS, GET_CURATION_LOADING, GET_CURATION_ERROR,
    PATCH_CURATION_SUCCESS, PATCH_CURATION_LOADING, PATCH_CURATION_ERROR
} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ""
};

export const GetCurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CURATION_LOADING: return { ...state, loading: action.data };
        case GET_CURATION_SUCCESS: return { ...state, payload: action.data, loading: false };
        case GET_CURATION_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const PatchCurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case PATCH_CURATION_LOADING: return { ...state, loading: action.data };
        case PATCH_CURATION_SUCCESS: return { ...state, payload: action.data, loading: false };
        case PATCH_CURATION_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};
